import type {
    OrderItemAccommodationRateItem_V2,
    OrderItemAccommodation_V2,
    OrderItemBookableQuantity_V2,
    OrderItemBookable_V2,
    OrderItemBuyable_V2,
    OrderItemDiscount_V2,
    OrderItemGenericDiscount_V2,
    OrderItemGiftCard_V2,
    OrderItemOptional_V2,
    OrderItemQuoteHead_V2,
    OrderItemUsedGiftCard_V2,
    OrderItemVoucher_V2,
    OrderItem_V2,
} from "./order-item-v2";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isOrderItem_V2 = (item: any): item is OrderItem_V2 => {
    return item._type === "ORDER_ITEM_V2";
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isOrderItemBuyable_V2 = (item: any): item is OrderItemBuyable_V2 => {
    return isOrderItem_V2(item) && item.acquireType === "BUYABLE";
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isOrderItemBookable_V2 = (item: any): item is OrderItemBookable_V2 => {
    return isOrderItem_V2(item) && item.acquireType === "BOOKABLE";
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isOrderItemOptional_V2 = (item: any): item is OrderItemOptional_V2 => {
    return isOrderItem_V2(item) && item.acquireType === "OPTIONAL";
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isOrderItemVoucher_V2 = (item: any): item is OrderItemVoucher_V2 => {
    return isOrderItem_V2(item) && item.acquireType === "VOUCHER";
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isOrderItemGiftCard_V2 = (item: any): item is OrderItemGiftCard_V2 => {
    return isOrderItem_V2(item) && item.acquireType === "GIFTCARD";
};
const isOrderItemUsedGiftCard_V2 = (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    item: any,
): item is OrderItemUsedGiftCard_V2 => {
    return isOrderItem_V2(item) && item.acquireType === "GIFTCARD_USED";
};

const isOrderItemDiscount_V2 = (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    item: any,
): item is OrderItemDiscount_V2 => {
    return isOrderItem_V2(item) && item.acquireType === "DISCOUNT";
};

const isOrderItemGenericDiscount_V2 = (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    item: any,
): item is OrderItemGenericDiscount_V2 => {
    return isOrderItem_V2(item) && item.acquireType === "GENERIC_DISCOUNT";
};
const isOrderItemBookableQuantity_V2 = (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    item: any,
): item is OrderItemBookableQuantity_V2 => {
    return isOrderItem_V2(item) && item.acquireType === "RESOURCE_REFERENCE";
};

const isOrderItemAccommodation_V2 = (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    item: any,
): item is OrderItemAccommodation_V2 => {
    return isOrderItem_V2(item) && item.acquireType === "ACCOMMODATION";
};

const isOrderItemAccommodationRateItem_V2 = (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    item: any,
): item is OrderItemAccommodationRateItem_V2 => {
    return (
        isOrderItem_V2(item) && item.acquireType === "ACCOMMODATION_RATE_ITEM"
    );
};

const isOrderItemQuoteHead = (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    item: any,
): item is OrderItemQuoteHead_V2 => {
    return isOrderItem_V2(item) && item.acquireType === "QUOTE_HEAD";
};

export {
    isOrderItemAccommodationRateItem_V2,
    isOrderItemAccommodation_V2,
    isOrderItemBookableQuantity_V2,
    isOrderItemBookable_V2,
    isOrderItemBuyable_V2,
    isOrderItemDiscount_V2,
    isOrderItemGenericDiscount_V2,
    isOrderItemGiftCard_V2,
    isOrderItemOptional_V2,
    isOrderItemQuoteHead,
    isOrderItemUsedGiftCard_V2,
    isOrderItemVoucher_V2,
    isOrderItem_V2,
};
